import React, { useState, useEffect } from "react";
import { Nav, Row } from "react-bootstrap";
import Parser from "html-react-parser";
import {
  iresOptionInfo,
  iresSupplierInfo,
} from "../../helpers/iresXMLFunctions";
import Itinerary from "../../elements/Itinerary";

const DealTabbedContent = ({
  optCode,
  includes,
  bookingConditions,
  itinerary,
  addon,
}) => {
  const [optInfo, setOptInfo] = useState(null);
  const [suppInfo, setSuppInfo] = useState(null);
  const [content, setContent] = useState("");

  useEffect(() => {
    //optCode && getDealData();
    setIncludes();
  }, []);

  const getDealData = async () => {
    let arr = [...optCode];
    let loc = "",
      type = "",
      supplier = "",
      code = "";
    arr.map((opt, index) => {
      if (index < 3) {
        loc += opt;
      } else if (index > 2 && index < 5) {
        type += opt;
      } else if (index > 4 && index < 11) {
        supplier += opt;
      } else {
        code += opt;
      }
    });

    let optionInfo = await iresOptionInfo(optCode);
    setOptInfo(optionInfo);
    let supplierInfo = await iresSupplierInfo(type, supplier);
    setSuppInfo(supplierInfo);
  };

  const setIncludes = () => {
    let text = <div>{Parser(includes)}</div>;
    setContent(text);
  };

  const setItinerary = () => {
    let text = <Itinerary data={itinerary} />;
    setContent(text);
  };

  const setAddOnInfo = () => {
    let text = <div>{Parser(addon)}</div>;
    setContent(text);
  };

  const setFacilities = () => {
    let text = <span>Facilities</span>;
    setContent(text);
  };

  const setLocation = () => {
    let text = <span>Location</span>;
    setContent(text);
  };

  const setFinePrint = () => {
    let text = (
      <div className="package-conditions small rounded">
        {Parser(bookingConditions)}
      </div>
    );
    setContent(text);
  };

  return (
    <>
      <Nav justify variant="tabs" defaultActiveKey="link-1">
        <Nav.Link
          onClick={() => setIncludes()}
          eventKey="link-1"
          className="nav-link deal-tab"
        >
          Includes
        </Nav.Link>

        {addon && (
          <Nav.Link
            onClick={() => setAddOnInfo()}
            eventKey="link-2"
            className="nav-link deal-tab"
          >
            Add On
          </Nav.Link>
        )}
        {/*
        <Nav.Link
          onClick={() => setFacilities()}
          eventKey="link-3"
          className="nav-link deal-tab"
        >
          Facilities
        </Nav.Link>

        <Nav.Link
          onClick={() => setLocation()}
          eventKey="link-4"
          className="nav-link deal-tab"
        >
          Location
        </Nav.Link> */}

        {itinerary && (
          <Nav.Link
            onClick={() => setItinerary()}
            eventKey="link-5"
            className="nav-link deal-tab"
          >
            Itinerary
          </Nav.Link>
        )}

        <Nav.Link
          onClick={() => setFinePrint()}
          eventKey="link-6"
          className="nav-link deal-tab"
        >
          Fine Print
        </Nav.Link>
      </Nav>
      <Row className="mt-3">
        <div className="container w-100">
          <div className="package-includes">{content}</div>
        </div>
      </Row>
    </>
  );
};

export default DealTabbedContent;
